// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2pCzF","name":"ConsentHeader_name__1nptF","birthday":"ConsentHeader_birthday__3i4dV","skeleton":"ConsentHeader_skeleton__2XAz2"};